import { EnergyAnalysisFileSection } from "features/dt-basic-setup/single-building/model/types";

import type { EpcModalPhase } from "./types";

export const MODAL_LAYOUT: Record<EpcModalPhase, { height: string; width: string }> = {
  analyzing: { height: "32rem", width: "62rem" },
  intro: { height: "auto", width: "62rem" },
  preview: { height: "53.125rem", width: "62rem" },
  upload: { height: "auto", width: "62rem" },
  uploading: { height: "32rem", width: "62rem" },
};

export const ENERGY_CERTIFICATE_SECTION: EnergyAnalysisFileSection = "energyCertificate";
export const EPC_ACCEPTED_EXTENSIONS = [".pdf"];
export const UPLOAD_COMPLETE_PERCENT = 100;
